export default "__VITE_ASSET__CbUxZD48__"